import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-zones',
  templateUrl: './all-zones.component.html',
  styleUrls: ['./all-zones.component.scss']
})
export class AllZonesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
